const schoolAdminLevelEnum = {
    View: "view",
    Edit: "edit",
};

export default schoolAdminLevelEnum;
